import { parseEntity } from '@/shared/converters/commonConverters';
import { DateTimeFormat, parseMoment } from '@/shared/converters/dateConverters';
import { isPresent } from '@/shared/utils/typescript';
import TaskDossier from '../models/TaskDossier';

export const SCHEMA = {
  id: 'dossierId',
  waitsOnPremise: 'waitsOnPremise',
  workStatus: (data: any) => data.dossierStatuses?.workStatus ?? data.workStatus,
  vehicleStatus: (data: any) => data.dossierStatuses?.objectStatus ?? data.objectStatus,
  parsOrderStatus: 'dossierStatuses.partsOrderStatus',
  checkedInAt: (data: any) => parseMoment(data.checkedInAt),
  checkedOutAt: (data: any) => parseMoment(data.checkedOutAt),
  pickUpAt: (data: any) => parseMoment(data.pickUpAt, DateTimeFormat.LEGACY),
};

export function parseTaskDossier(data: any): TaskDossier | null {
  if (!isPresent(data.dossierId)) return null;
  return parseEntity(data, SCHEMA, TaskDossier);
}